.sparkline {
    stroke: red;
    fill: none;
}  
